import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
import styles from './Card.module.css';
/** Surface-2 bg, hairline border, radius 14, sh-sm (CLAUDE_DESIGN.md §6.7). */
export function Card({ cover, padded = true, interactive = false, className, children, ...rest }) {
    return (_jsxs("div", { className: cn(styles['card'], interactive && styles['interactive'], className), ...rest, children: [cover && _jsx("div", { className: styles['cover'], children: cover }), _jsx("div", { className: cn(padded && styles['body']), children: children })] }));
}
